import { clearElement } from '../dom/element';

const maxResumeUploadSizeBytes = 8000000;

export default function initResumeUploadForm(): void {
    document.addEventListener( 'change', function( evt: Event ) {
        if ( !evt.target || !( evt.target instanceof HTMLElement ) || !evt.target.closest( '.attach-cv input[type=\'file\'][name^=\'resume\']' ) ) {
            return;
        }

        const input = evt.target as HTMLInputElement;
        const container = input.closest( '.attach-cv' ) as HTMLElement; // se check file is there

        if ( input.files && input.files.length > 0 ) {
            const formData = new FormData();
            const size = input.files[ 0 ].size; // file size in bytes,

            let errormsg = input.dataset.errorMsgToobig;
            const successmsg = input.dataset.msgSuccess;

            const parentForm = input.closest<HTMLFormElement>( 'form' );

            if ( !parentForm ) {
                return;
            }

            const msgcontainer = parentForm.querySelector<HTMLElement>( '.messages' );

            if ( !msgcontainer ) {
                return;
            }

            clearElement( msgcontainer );

            const process = container.querySelector<HTMLElement>( '.upload-process' );

            if ( !process ) {
                return;
            }

            process.style.display = 'inline';

            if ( size > maxResumeUploadSizeBytes ) {
                // 8000000 = +- 8MB
                msgcontainer.innerHTML = '<div class="alert alert-danger">' + errormsg + '</div>';
                return true;
            }

            formData.append( 'resume', input.files[ 0 ] );
            formData.append( 'json', 'yes' );

            window.http( input.dataset.uploadUrl as string, {
                method: 'POST',
                body: formData,
            } )
                .then( function( result ) {
                    process.style.display = 'none';
                    return result.json();
                } )
                .then( function( result ) {
                    clearElement( msgcontainer );

                    if ( result.success ) {
                        const select = container.querySelector( 'select.select-cv' ) as HTMLSelectElement;
                        select[ select.options.length ] = new Option( result.fileName, result.resumeId );
                        select.value = result.resumeId;

                        msgcontainer.innerHTML = `<div class="alert alert-success">${successmsg}</div>`;
                    } else if ( result.errors && result.errors.form ) {
                        errormsg = result.errors.form;
                        msgcontainer.innerHTML = `<div class="alert alert-danger">${errormsg}</div>`;
                    }

                    input.value = '';
                } );
        }
    } );
}
